import React from 'react'
import { Outlet } from 'react-router-dom'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

// ContentLayout clips overflow, so the admin area scrolls itself when a page is taller than the viewport.
// Each admin page renders its own AdminPageLayout (header band + content), like the Settings page.
const AdminRoutes: React.FC = () => {
  return (
    <ContentLayout style={{ overflowY: 'auto', overflowX: 'hidden' }}>
      <Outlet />
    </ContentLayout>
  )
}

export default AdminRoutes
